import React, {useState} from 'react';
import './home_partners.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {AddSubscribers} from "../../../redux/actions";
import {connect} from "react-redux";
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import {Navigation, Pagination,Autoplay} from 'swiper/modules';
import {generateFileMediaUrl} from "../../../utils/generateMediaUrl";


function HomePartner(props) {
    const {staticTexts,partners} = props
    const [activeIndex,setActiveIndex] = useState(false);

    return <div className={'partners_wrapper'}>
        <div  className={'partner_title'}>
            {staticTexts?.homepage_partners_title || 'Наши партнеры'}
        </div>
        <div className={'partners_slider'}>
            <Swiper
                effect={'flip'}
                spaceBetween={'16'}
                watchSlidesProgress={true}
                slidesPerView={1.3}
                pagination={false}
                modules={[Autoplay,Navigation, Pagination]}
                navigation={false}
                loop={true}
                allowTouchMove={true}
                autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                }}
                onRealIndexChange={(swiper) => {
                    setActiveIndex(swiper.realIndex)
                }}
                breakpoints={{
                    400: {
                        slidesPerView: 1.3,
                    },
                    600: {
                        slidesPerView: 2,
                    },
                    800: {
                        slidesPerView: 3,
                    },
                    1300: {
                        slidesPerView: 4,
                    },
                    1600: {
                        slidesPerView: 5,
                    },
                }}
            >

                {
                    partners?.map((item, index) => {
                        return (
                            <SwiperSlide key={index} className="partners_img_wrapper" onClick={() => window.open(item?.url, '_blank')}>
                                <img
                                    src={generateFileMediaUrl(item?.icon?.path)}
                                    alt=""
                                    className="partners_img"
                                />
                                <img
                                    src={generateFileMediaUrl(item?.hoverIcon?.path)}
                                    className="fade_image"
                                    title={item?.hoverIcon?.title || ''}
                                    alt={item?.hoverIcon?.altAttribute || ''}
                                />
                            </SwiperSlide>
                        );

                    })
                }
            </Swiper>
        </div>
    </div>

}
const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'requestLoading',
    'partners'
]);

const mapDispatchToProps = {
    AddSubscribers
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePartner);